import styled from 'styled-components';
import {
  ProductiveHeading03,
  BodyShort01,
  BodyLong01,
} from 'components/styles';

const Title = styled.div`
  ${ProductiveHeading03};
`;
const Description = styled.div`
  ${BodyLong01};
`;
const ListItem = styled.li`
  ${BodyShort01};
`;
const ListComponent = styled.ul`
  padding-left: var(--spacing-06);
  ${ListItem} {
    margin-bottom: var(--spacing-03);
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

type List = typeof ListComponent & {
  Item: typeof ListItem;
};

const List: List = ListComponent as any;

List.Item = ListItem;

const Actions = styled.div``;

const AuxillaryLinks = styled.div``;

const FeatureContent = styled.div`
  ${Title} {
    margin-bottom: var(--spacing-04);
  }
  ${List} {
    margin-bottom: var(--spacing-08);
  }
  ${Description} {
    margin-bottom: var(--spacing-08);
  }
  ${Actions} {
    margin-bottom: var(--spacing-05);
  }
`;

type Content = typeof FeatureContent & {
  Title: typeof Title;
  List: typeof List;
  Description: typeof Description;
  Actions: typeof Actions;
  AuxillaryLinks: typeof AuxillaryLinks;
};

const Content: Content = FeatureContent as any;

Content.Title = Title;
Content.List = List;
Content.Description = Description;
Content.Actions = Actions;
Content.AuxillaryLinks = AuxillaryLinks;

export { Content };
